import { IonIcon } from "@ionic/react";
import { logoWhatsapp } from "ionicons/icons";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import AnimatedBackground from "../../components/basicsComponents/AnimatedBackground/AnimatedBackground";
import { Button, Card, Link, Typography } from "@mui/joy";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useLoginForm from "./useLoginForm";
import "../../theme/tech-variables.css";
import "./Login.css";

const LoginIonic = () => {
  // Detectar si es móvil
  const isMobile = window.innerWidth <= 768;
  const {
    cargando,
    blnVerPassword,
    usuario,
    recordarme,
    errorUsuario,
    errorPassword,
    msjErrorPassword,
    toast,
    mostrarNotificacion,
    handleChangeVisibilityOfPassword,
    handleClickSubmit,
    handleChangeUsuario,
    handleChangePassword,
    handleChangeRecordarme,
    handleClickCopiarTelefono,
  } = useLoginForm();

  return (
    <div className="tech-login-container">
      {/* Fondo animado con gradientes y partículas */}
      <div className="tech-login-background"></div>
      <AnimatedBackground />

      {/* Card principal split-screen */}
      <Card
        className="tech-login-card tech-card-main"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <div
          className="tech-login-left tech-login-left-styled"
          style={{
            flex: isMobile ? "auto" : "0.6",
            borderRight: isMobile
              ? "none"
              : "1px solid rgba(255, 255, 255, 0.2)",
            order: isMobile ? 1 : 0,
          }}
        >
          <div className="tech-decorative-pattern"></div>
          <div className="tech-content-wrapper">
            <div className="tech-logo-container">
              <img
                alt="Logo clinica"
                src="assets/icon/logo-consultorio.png"
                className="tech-left-logo"
              />
            </div>

            <Typography className="tech-left-title">
              Portal del Paciente
            </Typography>

            {/* Texto de bienvenida - Solo visible en desktop */}
            {!isMobile && (
              <Typography className="tech-left-title">
                Te damos la bienvenida a tu espacio de salud en Consultorios
                Médicos Villa Allende. Gestioná tus turnos, actualizá tus datos
                y comunicate con nosotros de manera fácil, rápida y segura, todo
                en un solo lugar.
              </Typography>
            )}
          </div>
        </div>

        <div
          className="tech-login-right tech-login-right-styled"
          style={{
            flex: isMobile ? "auto" : 1,
            flexDirection: "column",
            justifyContent: "center",
            order: isMobile ? 2 : 0,
          }}
        >
          {isMobile && (
            <div className="tech-mobile-header">
              <img
                alt="Logo clinica"
                src="assets/icon/logo-consultorio.png"
                className="tech-mobile-header-logo"
              />
            </div>
          )}

          <Typography
            className="tech-right-title"
            style={{
              background: "var(--gradient-primary)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              fontFamily: "var(--font-display)",
              fontWeight: 600,
              fontSize: "clamp(1.1rem, 2.5vw, 1.3rem)",
              marginBottom: "clamp(1.5rem, 3vh, 2rem)",
              textAlign: "center",
              letterSpacing: "-0.02em",
            }}
          >
            Ingresa tus credenciales
          </Typography>

          <form className="tech-login-form" noValidate autoComplete="off">
            <div>
              <label className="tech-input-label">Documento</label>
              <input
                className={`tech-input ${errorUsuario ? "error" : ""}`}
                type="text"
                placeholder="Ingrese su documento..."
                value={usuario.usuario}
                onChange={handleChangeUsuario}
              />
              {errorUsuario && (
                <div className="tech-error-message">
                  Por favor ingrese un documento válido
                </div>
              )}
            </div>

            <div className="tech-password-wrapper">
              <label className="tech-input-label">Contraseña</label>
              <input
                className={`tech-input tech-password-input-styled ${errorPassword ? "error" : ""}`}
                type={blnVerPassword ? "text" : "password"}
                placeholder="Ingrese su contraseña..."
                value={usuario.password}
                onChange={handleChangePassword}
                style={{
                  paddingRight: window.innerWidth <= 767 ? "35px" : "40px",
                }}
              />
              <Button
                onClick={handleChangeVisibilityOfPassword}
                type="button"
                variant="plain"
                color="neutral"
                size="sm"
                className="password-toggle-btn"
                sx={{
                  position: "absolute",
                  right: window.innerWidth <= 767 ? "4px" : "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  minWidth: window.innerWidth <= 767 ? "20px" : "24px",
                  minHeight: window.innerWidth <= 767 ? "20px" : "24px",
                  borderRadius: "50%",
                  backgroundColor: "transparent",
                  border: "none",
                  color: "var(--color-text-secondary)",
                  zIndex: 10,
                  "&:hover": {
                    backgroundColor: "rgba(102, 126, 234, 0.1)",
                    color: "var(--color-primary)",
                  },
                }}
              >
                {blnVerPassword ? <Visibility /> : <VisibilityOff />}
              </Button>
              {errorPassword && (
                <div className="tech-error-message">{msjErrorPassword}</div>
              )}
              {!errorPassword && (
                <div
                  style={{
                    fontSize: "0.75rem",
                    color: "var(--color-text-secondary)",
                    marginTop: "4px",
                    paddingLeft: "4px",
                  }}
                >
                  Si no cambio su contraseña, ingrese su numero de documento
                </div>
              )}
            </div>

            {/* Link olvidaste contraseña 
            <div className="tech-forgot-password-container">
              <Link 
                href="#" 
                sx={{ 
                  fontSize: '0.85rem',
                  color: 'var(--color-primary)',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                ¿Olvidaste tu contraseña?
              </Link>
            </div>*/}

            <button
              className="tech-button"
              type="button"
              onClick={handleClickSubmit}
              disabled={cargando}
            >
              {cargando ? "Ingresando..." : "Ingresar"}
            </button>

            {/* Checkbox recordarme */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "var(--spacing-sm)",
                marginTop: "var(--spacing-md)",
              }}
            >
              <input
                type="checkbox"
                id="remember"
                checked={recordarme}
                onChange={handleChangeRecordarme}
                style={{
                  accentColor: "var(--color-primary)",
                  transform: "scale(1.1)",
                }}
              />
              <label
                htmlFor="remember"
                style={{
                  fontSize: "0.9rem",
                  color: "var(--color-text-secondary)",
                  cursor: "pointer",
                }}
              >
                Recordarme
              </label>
            </div>

            {/* Info para registro */}
            <div className="tech-register-info">
              <Typography className="tech-help-text">
                ¿Todavía no tienes cuenta?
              </Typography>

              <Typography className="tech-whatsapp-info-text">
                Primera vez con nosotros? Regístrate por WhatsApp.
              </Typography>
              <a
                href="https://api.whatsapp.com/send?phone=+5493543575833&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20registrarme%20como%20paciente."
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClickCopiarTelefono}
                className="tech-whatsapp-link"
              >
                <IonIcon icon={logoWhatsapp} size="small" />
                Registrarse
              </a>
            </div>
          </form>
        </div>
      </Card>

      <div className="tech-login-footer">
        <Link
          className="tech-footer-link"
          href="https://www.gacitua.com.ar/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography sx={{ color: "inherit" }}>Powered by</Typography>
          <img
            src="assets/icon/logoGacitua.png"
            alt="logo gacitua y asociados"
            width={20}
            height={20}
            className="tech-footer-logo-img"
          />
          <Typography sx={{ color: "inherit", fontWeight: "500" }}>
            Gacitua & Asociados
          </Typography>
        </Link>
      </div>

      <CustomToast
        openToast={toast.open}
        onDidDismiss={() => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />

      {cargando && (
        <div className="tech-loading-overlay">
          <div className="tech-loading-spinner"></div>
        </div>
      )}
    </div>
  );
};

export default LoginIonic;
